import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/*
 * @Author: thl
 * @Date: 2023-11-08 14:45:11
 * @LastEditors: yyz
 * @LastEditTime: 2025-12-12 12:00:17
 */
export var customerRouter = [{
  path: '/customer-details',
  component: function component() {
    return import('@/views/group-customers-information-new/index.vue');
  },
  meta: {
    title: '群客户资料',
    keepAlive: false
  },
  children: []
}, {
  path: '/choose-project',
  component: function component() {
    return import('@/views/group-customers-information-new/pages/chooseProject.vue');
  },
  meta: {
    title: '选择项目',
    keepAlive: false
  },
  children: []
}, {
  path: '/deal-order-detail',
  component: function component() {
    return import('@/views/group-customers-information-new/pages/dealOrderDetail.vue');
  },
  meta: {
    title: '订单详情',
    keepAlive: false
  },
  children: []
}, {
  path: '/demand-detail',
  component: function component() {
    return import('@/views/group-customers-information-new/pages/demandDetail.vue');
  },
  meta: {
    title: '需求详情',
    keepAlive: false
  },
  children: []
}, {
  path: '/set-programmanager',
  component: function component() {
    return import('@/views/group-customers-information-new/pages/setProgramManager.vue');
  },
  meta: {
    title: '配置方案经理',
    keepAlive: false
  },
  children: []
},
// 写跟进
{
  path: '/customer-write-follow',
  component: function component() {
    return import('@/views/group-customers-information-new/pages/write-follow/index.vue');
  },
  meta: {
    title: '写跟进',
    keepAlive: false
  },
  children: []
},
// 常用语
{
  path: '/cutomer-phrasePage',
  component: function component() {
    return import('@/views/group-customers-information-new/pages/write-follow/page/phrase-page.vue');
  },
  meta: {
    title: '写跟进',
    keepAlive: false
  },
  children: []
},
// 生产待办
{
  path: '/production-backlog-list',
  component: function component() {
    return import('@/views/production-backlog/list.vue');
  },
  meta: {
    title: '生产待办列表',
    keepAlive: false
  },
  children: []
}, {
  path: '/production-backlog-detail',
  component: function component() {
    return import('@/views/production-backlog/details.vue');
  },
  meta: {
    title: '生产待办详情',
    keepAlive: false
  },
  children: []
}, {
  path: '/production-backlog-completeTask',
  component: function component() {
    return import('@/views/production-backlog/completeTask.vue');
  },
  meta: {
    title: '生产待办完成任务',
    keepAlive: false
  },
  children: []
}, {
  path: '/agent-accounting-boundInfo',
  component: function component() {
    return import('@/views/agent-accounting/bound-info.vue');
  },
  meta: {
    title: '代理记账列表',
    keepAlive: false
  },
  children: []
}, {
  path: '/agent-accounting-customerList',
  component: function component() {
    return import('@/views/agent-accounting/customer-list.vue');
  },
  meta: {
    title: '绑定客户列表',
    keepAlive: false
  },
  children: []
}, {
  path: '/robot-send-message',
  name: 'robotSendMessage',
  component: function component() {
    return import('@/views/robotSendMessage/index.vue');
  },
  meta: {
    title: '自动发送群消息',
    keepAlive: false
  }
}, {
  path: '/joinGroupChat',
  name: 'joinGroupChat',
  component: function component() {
    return import('@/views/joinGroupChat/index.vue');
  },
  meta: {
    title: '扫码加入群聊',
    keepAlive: false
  }
}, {
  path: '/delivery-management-bindingList',
  name: 'deliveryManagementBindingList',
  component: function component() {
    return import('@/views/delivery-management/binding-list');
  },
  meta: {
    title: '交付管理',
    keepAlive: false
  }
}, {
  path: '/delivery-management-customerDetail',
  name: 'deliveryManagementCustomerDetail',
  component: function component() {
    return import('@/views/delivery-management/customer-detail');
  },
  meta: {
    title: '私客详情',
    keepAlive: false
  }
}, {
  path: '/delivery-management-productionList',
  name: 'deliveryManagementproductionList',
  component: function component() {
    return import('@/views/delivery-management/production-list');
  },
  meta: {
    title: '生产单列表',
    keepAlive: false
  }
}, {
  path: '/delivery-management-productProgress',
  name: 'deliveryManagementProductProgress',
  component: function component() {
    return import('@/views/delivery-management/production-progress');
  },
  meta: {
    title: '生产进度',
    keepAlive: false
  }
}, {
  path: '/delivery-management-nodeDetails',
  name: 'deliveryManagementNodeDetails',
  component: function component() {
    return import('@/views/delivery-management/node-details');
  },
  meta: {
    title: '节点详情',
    keepAlive: false
  }
}, {
  path: '/delivery-management/add-delivery',
  name: 'deliveryManagementAddDelivery',
  component: function component() {
    return import('@/views/delivery-management/add-delivery');
  },
  meta: {
    title: '添加交付物',
    keepAlive: false
  }
}];